import { Component, Inject, Input } from '@angular/core';
import { PickupViewModel } from '../reservation.page';
import { SCREEN_LAYOUT, ScreenLayout } from '../../core/layout/layout.provider';

@Component({
    selector: 'app-pickup-overview',
    styles: [`
    :host {
      display: block;
    }
  `],
    template: `
    <div class="list-group-item list-group-item-action border-bottom border-top-0 border-start-0 border-end-0">
      <div class="d-none d-md-flex flex-row pt-3 pb-3 align-items-center">
        <div class="d-flex align-items-center col-9">
          <span class="position-relative">
            <span class="material-icons md-48">account_circle</span>
          </span>
          <div class="d-flex flex-column mx-2">
            <div>
              Verkauf: <span class="fw-bold pickup-id">#{{ item.id }}</span>
            </div>
            <div *ngIf="item.pickupAt">
              <span i18n>Bestellung vom {{ item.pickupAt.toFormat('dd.MM.yyyy, HH:mm') }} Uhr</span>
            </div>
            <div>
              <span class="fw-bold pickup-name">
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex-column d-flex align-items-end ps-3 col-3 pe-3">
          <span class="flex-row fs-6 text-info fw-bold text-end">
            {{ calculateOverallPrice() | currency}}
          </span>
        </div>
      </div>

      <div class="d-flex d-md-none flex-row pt-3 pb-3 align-items-center justify-content-between">
        <div class="d-flex align-items-center overflow-x-hidden">
          <span class="position-relative">
            <span class="material-icons md-48">account_circle</span>
          </span>
          <div class="d-flex flex-column mx-2 overflow-hidden">
            <div>
              Verkauf: <span class="fw-bold pickup-id">#{{ item.id }}</span>
            </div>
            <div *ngIf="item.pickupAt">
              <span i18n>Bestellung vom {{ item.pickupAt.toFormat('dd.MM.yyyy, HH:mm') }} Uhr</span>
            </div>
            <div>
              <span class="fw-bold pickup-name">
                {{ item.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="ps-2">
          <span class="fs-6 text-info fw-bold text-end">
            {{ calculateOverallPrice() | currency}}
          </span>
        </div>
      </div>
    </div>
    <app-pickup-overview-item *ngFor="let pi of item.items" [item]="pi" class="list-group-item list-group-item-action border-bottom border-top-0 border-start-0 border-end-0"></app-pickup-overview-item>
  `,
    standalone: false
})
export class PickupOverviewComponent {
  @Input() item!: PickupViewModel;

  constructor(
    @Inject(SCREEN_LAYOUT) public layout: ScreenLayout
  ) {
  }

  calculateOverallPrice() {
    return this.item.items.reduce((acc, item) => acc + +(item.product.price || 0), 0);
  }
}
